const INITIAL = [];

export function pendingBrokersReducer(state = INITIAL, action) {
  
  if(action.type === 'PENDING_BROKERS') {
        const updatedData = [...action.data];
        return [...updatedData]
    }
    return state;
}